import { useEffect, useMemo, useState } from "react";
import CustomDataTable from "../../../components/CustomDataTable";
import { AgentsService } from "../../../services/AgentsService";
import { AlertService } from "../../../services/Alert";
import FormModal from "./FormModal";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
function AgentStatusPartial() {
    
    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    
    const [statuses, setStatuses] = useState<any>()
    const [showModal, setShowModal] = useState(false);
    const [stateId, setStateId] = useState(0);

    const columns = useMemo(() => [
        {
            name: t("config.status-agent.name"),
            sortable: true,
            selector: row => row.name,
        },
        {
            name: t("config.status-agent.subaccount"),
            sortable: true,
            selector: row => row.sub_account_name ? row.sub_account_name: <span className="badge bg-warning ">{t("config.status-agent.no-subaccount")}</span>,
        },        
        {
            name: t("config.status-agent.assign-tickets"),
            sortable: true,
            cell: (row) => {
                return (
                    row.messages_restriccion === 1 ?
                        (
                            <span className="badge bg-soft-info text-info">
                                <span className="legend-indicator bg-info"></span> {t("config.status-agent.active")}
                            </span>
                        ) :
                        (
                            <span className="badge bg-soft-danger text-danger">
                                <span className="legend-indicator bg-danger"></span> {t("config.status-agent.inactive")}
                            </span>
                        )
                )
            }
        },

        {
            name: t("config.status-agent.actions"),
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-white btn-sm" onClick={() => deleteState(row)}>
                            {t("config.status-agent.delete")}
                        </button>

                        <div className="btn-group">
                            <button type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item" onClick={() => setMessagesRestriccion(row)}>
                                    {
                                        row.messages_restriccion === 1 ? t("config.status-agent.disable-tickets")  : t("config.status-agent.enable-tickets") 
                                    }
                                </button>
                            </div>
                        </div>

                    </div>
                )
            }
        },
    ], []);

    const deleteState = async(state) => {
        const isConfirmed = await AlertService.warning('Aviso', `¿Estás seguro de querer borrar este estado? Esta acción no se puede deshacer`, async () => {
            try {

                await AgentsService.deleteState(state.id)
                await getStatuses()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al borrar el estado, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se borro el estatus correctamente', 'Ok');
        }
    }

    const setMessagesRestriccion = async(state) => {
        const isConfirmed = await AlertService.warning('Aviso', `¿Estás seguro de querer ${!state.messages_restriccion ? 'ACTIVAR': 'DESACTIVAR'} la asignación de tickets?`, async () => {
            try {

                await AgentsService.setMessagesRestriccion(state.messages_restriccion ? 0: 1, state.id )
                await getStatuses()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar la asignación de tickets, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se cambio el estatus correctamente', 'Ok');
        }
    }

    const getStatuses = async() => {
        const { data } = await call(() => AgentsService.getStatuses(account.id));
        setStatuses(data)
    }

    const onCloseModal = async(reload: boolean) => {
        
        if(reload) {
            await getStatuses()    
        }

        setShowModal(false)
    }

    useEffect(() => {
        getStatuses()
    }, [])
    
    
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4"> {t("config.status-agent.status-title")}</h2>
                        <p className="small mb-0">
                            {t("config.status-agent.status-p")}
                        </p>
                    </div>

                    <div className="col-sm-auto">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                // setStateId(row)
                                setShowModal(true)
                            }}
                        >
                            <i className="bi-plus-lg me-1"></i>
                            {t("config.status-agent.create-status")}
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    <CustomDataTable
                        columns={columns}
                        data={ statuses ? statuses.all_status : [] }
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.sub_account_name}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
            </div>

            <FormModal
                show={showModal}
                onRequestClose={onCloseModal}
                status_table_id={statuses?.status_table_id}
            />

        </>
    )
}
export default AgentStatusPartial